import React from "react"
import img from "../images/pricing.jpg"
import Back from "../common/Back"
import "./contact.css"

const Contact = () => {
  return (
    <>
      <section className='contact '>
        <Back name='Contact Us' title='Get Helps & Friendly Support' cover={img} />
        <div className='container'>
          <form className='shadow'>
            <h4>Fillup The Form</h4> <br />
           
              <input type='text' placeholder='Name' />
              
              <input type='eamil' placeholder='Email' />
              <input type='tel' placeholder='Phone' />
              <input type='text' placeholder='Subject' />
             
                        
            <textarea cols='30' rows='5' placeholder='Details'></textarea>
            <button>Submit Request</button>
          </form>
        </div>
      </section>
    </>
  )
}

export default Contact